/**
 * Utils to help make sense of the various layer policies.
 *
 * @module
 */

/**
 * @constant
 * @type {string}
 * @private
 */
var SINGLE_EXPERIMENT = 'single_experiment';

/**
 * @constant
 * @type {string}
 */
var MULTIVARIATE = 'multivariate';

/**
 *
 * @param {string} policy
 * @returns {boolean}
 */
exports.isSingleExperimentPolicy = function(policy:string): boolean {
  return policy === SINGLE_EXPERIMENT || policy === MULTIVARIATE;
};
